<div class="d-flex flex-column gap-2">
  <div>{{ titleJurisdictionId | governingJurisdictionName }}</div>
  <div *ngIf="originalJurisdictionId !== null" class="original-jurisdiction">
    <span class="visually-hidden" i18n>Original jurisdiction:</span>
    {{ originalJurisdictionId | governingJurisdictionName }}
  </div>
</div>
